import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { BiometriaBaseAPI } from "./biometria.base.api";

export class BiometriaApi extends BiometriaBaseAPI<any> {
  constructor() {
    super();
  }

  public validaBiometria(
    biometria: string
  ): AxiosObservable<any> {
    return this.axios.post(`${this.urlAutomacao}${this.ambienteAutomacao}/vaivemEstudante/validarBiometria`,
      {
        "foto": biometria
      },
    );
  };
}
